import { enableProdMode, APP_INITIALIZER, importProvidersFrom, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PrimeNgModule } from './app/layout/shared/prime-ng/prime-ng.module';
import { AppLayoutModule } from './app/layout/app.layout.module';
import { AppRoutingModule } from './app/app-routing.module';
import { AuthInterceptorService } from './app/services/auth/auth-interceptor.service';
import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpClient,
  withInterceptorsFromDi,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { EnvConfigService } from './app/services/utils/env-config.service';
import * as envProd from 'src/environments/environment.prod';
import { fechasInterceptor } from './app/services/fechas.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { firstValueFrom, timeout } from 'rxjs';
import { sincronizarRelojServidor } from './app/utils/fechas-utils';

if (environment.production) {
  enableProdMode();

  window.console.log = () => {};
} else {
  environment.dev = true;
}

export function initializeApp(configService: EnvConfigService, httpBackend: HttpBackend) {
  return (): Promise<any> => {
    return configService
      .loadConfig()
      .toPromise()
      .then(async (config) => {
        configService.setConfig(config);
        environment.API_URL = configService.apiUrl;
        envProd.environment.API_URL = configService.apiUrl;
        // Initialize before components choose their default day/month/year.
        const clock = await firstValueFrom(new HttpClient(httpBackend).get<{
          data: { server_time: string; server_timezone: string }
        }>(configService.apiUrl.replace(/\/$/, '') + '/server-time').pipe(timeout(15000)));
        sincronizarRelojServidor(clock.data.server_time, clock.data.server_timezone);
      });
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule, AppLayoutModule, PrimeNgModule),
    EnvConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [EnvConfigService, HttpBackend],
      multi: true
    },
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([fechasInterceptor])),
    provideAnimations(),
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'USD'
    },
    provideAnimationsAsync()
  ]
}).catch((err) => console.error(err));
